export default {
  getLoginInfo(state){
    return state.loginInfo
  },
  getPageLoad(state){
    return state.pageLoad
  },
  getUser(state){
    return state.user
  }
}



// WEBPACK FOOTER //
// ./src/store/axj-web/getters.js